import React from "react";
import { Form, Input, Button } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle, faMinusCircle } from "@fortawesome/free-solid-svg-icons";

const CustomInputNumber = ({
  name,
  label,
  min = 0,
  max = 9,
  defaultValue = 1,
  form,
}) => {
  return (
    <div className="flex flex-col w-full">
      {label}
      <div
        className="h-[48px] flex items-center  px-3 py-1 w-full rounded-[8px] max-w-[110px] bg-[#F5F6F6]"
        style={{ border: "1px solid #d9d9d9" }}
      >
        <Button
          className="mr-1 border-0 p-0 "
          style={{ width: "10px", height: "10px" }}
          onClick={() => {
            const currentVal = form.getFieldValue(name);
            if (currentVal > min) {
              form.setFieldsValue({
                [name]: currentVal - 1,
              });
            }
          }}
        >
          <img src={"/images/minus.svg"} alt="" />
        </Button>

        <Form.Item
          className="mb-0 grow"
          name={name}
          initialValue={defaultValue}
        >
          <Input
            type="number"
            min={min}
            max={max}
            className="text-center text-[15px] font-semibold"
            value={form.getFieldValue(name)}
            variant="borderless"
          />
        </Form.Item>

        <Button
          className="ml-1 border-0 p-0 "
          style={{ width: "10px", height: "10px" }}
          onClick={() => {
            const currentVal = form.getFieldValue(name);
            if (currentVal < max) {
              form.setFieldsValue({
                [name]: currentVal + 1,
              });
            }
          }}
        >
          <img src={"/images/plus.svg"} alt="" />
        </Button>
      </div>
    </div>
  );
};

export default CustomInputNumber;
